"use client";

import { useHeaderMotion } from "@/components/site/motion/useChromeMotion";
import { useMotion } from "@/components/site/motion/MotionContext";
import {
  BrandWordmark,
  BrandXMark,
} from "@/components/icons/SiteMarks";
import { useContent } from "@/components/site/ContentProvider";

const SHOW_LOCALE_SWITCHER = true;

export function Header() {
  useHeaderMotion(useMotion());
  const site = useContent();

  return (
    <header className="_tempHide">
      <div className="header_set f a-c j-c">
        <div className="header_side f a-c j-c _update">
          <div className="header_expand_set">
            <div className="header_expand f a-c j-c" aria-hidden="true">
              <BrandWordmark className="header_expand_mark" />
            </div>
          </div>
          <div className="header_menu f a-c">
            <a
              href="#"
              className="main_logo _ele f a-c jump_link"
              aria-label={site.aria.home}
              data-section="hero"
            >
              <BrandWordmark className="header_logo_mark" />
            </a>
            <nav>
              <ul className="f a-c">
                {site.nav.map((item) => (
                  <li className="_ele" key={item.section}>
                    <a
                      href="#"
                      className="jump_link"
                      aria-label={item.label}
                      data-section={item.section}
                    >
                      <BrandXMark className="nav_x" />
                      <strong className="label">{item.label}</strong>
                      <BrandXMark className="nav_x" />
                    </a>
                  </li>
                ))}
              </ul>
            </nav>
          </div>
        </div>
        <div className="header_side f a-c">
          {SHOW_LOCALE_SWITCHER ? (
            <a
              href={site.localeSwitch.href}
              className="site_btn-like f a-c j-c"
              aria-label={site.localeSwitch.aria}
            >
              <strong className="label">{site.localeSwitch.label}</strong>
            </a>
          ) : null}
          <a
            href="#"
            className="site_btn f a-c j-c jump_link"
            aria-label={site.cta.label}
            data-section={site.cta.section}
          >
            <strong className="label">{site.cta.label}</strong>
          </a>
        </div>
      </div>
    </header>
  );
}
